import type { FC, ReactNode } from "react";

export const PartnerSection: FC<{
    title: string;
    children: ReactNode;
    headingLevel: 1 | 2;
}> = ({ title, children, headingLevel }) => {
    return (
        <div
            className={
                "border-b border-[var(--color-border-strong)] p-2 [&_p]:leading-8 [&_p]:text-md " +
                "[&_p]:text-[var(--color-text-secondary)]"
            }
        >
            {
                headingLevel === 1 ?
                    <h1 className="mt-0 text-4xl">{title}</h1> :
                    <h2 className="text-2xl">{title}</h2>
            }
            {children}
        </div>
    );
};
